import React from 'react';
import ReactDOM from 'react-dom/client';
/*import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";*/
//import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
//import { ErrorPage } from './components/ErrorPage';

import reportWebVitals from './reportWebVitals';

/*const router = createBrowserRouter([
  {
    path: "/",
    index: true,
    element: <App />,
  },
]);*/


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
